/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ReplicationResponse } from '../../models/replication-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface ReplicateAll$Params {}

export function replicateAll(
  http: HttpClient,
  rootUrl: string,
  params?: ReplicateAll$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReplicationResponse>> {
  const rb = new RequestBuilder(rootUrl, replicateAll.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReplicationResponse>;
    }),
  );
}

replicateAll.PATH = '/service/v1/claimRecourseReplication/replicateAll';
